import ResetPassword from "./ResetPassword.jsx";

export default ResetPassword;
